export const SIMPLE_TEXT = "SIMPLE_TEXT"
export const BARCODE = "BARCODE"
export const VARIABLE_TEXT = "VARIABLE_TEXT"
export const PICTURE = "PICTURE"
export const VARIABLE_PICTURE = "VARIABLE_PICTURE"
export const HORIZONTAL_LINE = "HORIZONTAL_LINE"
export const VERTICAL_LINE = "VERTICAL_LINE"
